import { useEffect, useState } from "react";
import { Modal, Spinner, Row, Col, Card, Badge } from "react-bootstrap";
import { getAllData, getStatusCarga } from "../../services/Servicos";
import "./ModalError.scss";
import { useSelector } from "react-redux";
import UserAvatar from "../common/UserAvatar";
import { returnDataWithCorrection } from "../../services/helpers";

export default function ModalVisualizarCarga({ show, setShow, cargaId }) {
  const user = useSelector((state) => state.userSlice);
  const caminhoesFrete = user.freteiroList.data || [];
  const funcionarios = user.funcionariosList.data || [];
  const caminhoneiros = [
    ...funcionarios.filter((f) => f.tipo === "Caminhoneiro"),
    ...caminhoesFrete.map((c) => ({
      name: c.motorista_nome,
      cpf: c.motorista_cpf,
      foto_perfil: c.foto_perfil,
    })),
  ];

  const [loading, setLoading] = useState(true);
  const [cargaData, setCargaData] = useState(null);
  const [error, setError] = useState(false);

  const handlerClose = () => {
    setShow({ flag: false, cargaId: null });
    setCargaData(null);
    setError(false);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return returnDataWithCorrection(dateString)
    .toLocaleString("pt-br",{ timeZone: "UTC" })
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";
    return returnDataWithCorrection(dateString)
    .toLocaleString("pt-br",{ timeZone: "UTC" })
  };

  const getStatusBadge = (status) => {
    const statusText = getStatusCarga(status) || "Desconhecido";

    // Função para determinar a cor do badge baseada no status
    const getStatusVariant = (status) => {
      if (status <= 0) return "danger"; // Indisponível, manutenção, etc.
      if (status <= 5) return "warning"; // Separação, planejamento
      if (status <= 8) return "info"; // Aguardando aprovações
      if (status <= 12) return "primary"; // Carregamento, entrega
      if (status >= 13) return "success"; // Entregue, finalizado
      return "secondary"; // Desconhecido
    };

    return (
      <Badge bg={getStatusVariant(status)} className="fs-6">
        {statusText}
      </Badge>
    );
  };

  useEffect(() => {
    if (!cargaId || !show) return;

    setLoading(true);
    setError(false);

    getAllData(`cargas?id=${cargaId}`)
      .then((response) => {
        setCargaData(response.data[0]);
      })
      .catch((error) => {
        console.error("Erro ao buscar dados da carga:", error);
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [cargaId, show]);

  return (
    <Modal
      show={show}
      onHide={handlerClose}
      backdrop="static"
      keyboard={false}
      size="lg"
      centered
    >
      <Modal.Header closeButton className="bg-primary text-white">
        <Modal.Title>
          <i className="bi bi-truck me-2"></i>
          Detalhes da Carga {cargaId ? `#${cargaId}` : ""}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-4">
        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
            <p className="mt-3 text-muted">Carregando dados da carga...</p>
          </div>
        ) : error ? (
          <div className="text-center py-5">
            <i className="bi bi-exclamation-triangle text-danger fs-1"></i>
            <h5 className="text-danger mt-3">Erro ao carregar dados</h5>
            <p className="text-muted">
              Não foi possível carregar os detalhes da carga.
            </p>
          </div>
        ) : cargaData ? (
          <div>
            {/* Informações Gerais */}
            <Card className="mb-4 border-0 shadow-sm">
              <Card.Header className="bg-light">
                <h6 className="mb-0">
                  <i className="bi bi-info-circle me-2"></i>
                  Informações Gerais
                </h6>
              </Card.Header>
              <Card.Body>
                <Row>
                  <Col md={6} className="mb-3">
                    <strong className="text-muted">ID da Carga:</strong>
                    <div className="fs-5 fw-bold text-primary">
                      #{cargaData.id}
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <strong className="text-muted">Status:</strong>
                    <div className="mt-1">
                      {getStatusBadge(cargaData.status)}
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <strong className="text-muted">Data de Criação:</strong>
                    <div>{formatDateTime(cargaData.emissao)}</div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <strong className="text-muted">Data de Separação:</strong>
                    <div>{formatDateTime(cargaData.data_separacao)}</div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <strong className="text-muted">Data de Carregamento:</strong>
                    <div>{formatDateTime(cargaData.data_carregamento)}</div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <strong className="text-muted">Saiu para Entrega:</strong>
                    <div>{formatDate(cargaData.data_inicio_entrega)}</div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <strong className="text-muted">Data de Entrega:</strong>
                    <div>{formatDate(cargaData.data_chegada)}</div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <strong className="text-muted">Rota:</strong>
                    <div>{cargaData.nome}</div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <strong className="text-muted">observacao:</strong>
                    <div>{cargaData.observacao.length ? cargaData.observacao :  "Sem observações"}</div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {/* Informações do Transporte */}
            <Card className="mb-4 border-0 shadow-sm">
              <Card.Header className="bg-light">
                <h6 className="mb-0">
                  <i className="bi bi-truck me-2"></i>
                  Transporte
                </h6>
              </Card.Header>
              <Card.Body>
                <Row>
                  <Col md={6} className="mb-3">
                    <strong className="text-muted">Motorista:</strong>
                      <UserAvatar
                        size="small"
                        user={caminhoneiros.find(
                          (c) => c.cpf === cargaData.caminhoneiro
                        )}
                      />
                  </Col>
                  <Col md={6} className="mb-3">
                    <strong className="text-muted">Frete:</strong>
                    <div className="fs-6">
                      {cargaData.tipo_transporte == 'FRETE'? "SIM" : "NÃO"}
                    </div>
                  </Col>
                  <Col md={6} className="d-flex flex-column align-items-start mb-3">
                    <strong className="text-muted">Placa:</strong>
                    <span className="badge bg-dark">
                      {cargaData.caminhao || "Caminhão não atribuido a carga"}
                    </span>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {/* Informações Financeiras */}
            <Card className="mb-4 border-0 shadow-sm">
              <Card.Header className="bg-light">
                <h6 className="mb-0">
                  <i className="bi bi-boxes me-2"></i>
                  Informações Extras
                </h6>
              </Card.Header>
              <Card.Body>
                <Row>
                  <Col md={6} className="mb-3">
                    <strong className="text-muted">Pedidos:</strong>
                    <div className="fs-6">
                      {cargaData.qtde_pedidos ?? 0}
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <strong className="text-muted">Produtos:</strong>
                    <div className="fs-6">
                      {cargaData.qtde_produtos ?? 0}
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <strong className="text-muted">Embalagens:</strong>
                    <div className="fs-6">
                      {cargaData.embalagens ?? 0}
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <strong className="text-muted">Transferências:</strong>
                    <div className="fs-6">
                      {cargaData.transferencias ?? 0}
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {/* Observações */}
            {cargaData.observacoes && (
              <Card className="border-0 shadow-sm">
                <Card.Header className="bg-light">
                  <h6 className="mb-0">
                    <i className="bi bi-chat-left-text me-2"></i>
                    Observações
                  </h6>
                </Card.Header>
                <Card.Body>
                  <p className="mb-0 text-muted">{cargaData.observacoes}</p>
                </Card.Body>
              </Card>
            )}
          </div>
        ) : (
          <div className="text-center py-5">
            <i className="bi bi-box text-muted fs-1"></i>
            <h5 className="text-muted mt-3">Nenhum dado encontrado</h5>
            <p className="text-muted">
              Não foram encontrados detalhes para esta carga.
            </p>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="bg-light">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handlerClose}
        >
          <i className="bi bi-x-circle me-2"></i>
          Fechar
        </button>
      </Modal.Footer>
    </Modal>
  );
}
